export default __webpack_public_path__ + "static/media/d9896899-f08c-4750-a874-a9e10d83c2cb.a60bb3b9.woff2";